import React from 'react';
import PropTypes from 'prop-types'; // Recommended for type checking in plain JavaScript/React

/**
 * Capitalizes the first letter of a string and converts the rest to lowercase.
 * Returns 'N/A' if the label is falsy (empty, null, undefined).
 *
 * @param {string | null | undefined} label - The input string.
 * @returns {string} The capitalized string or 'N/A'.
 */
const capitalizeFirstLetter = (label) => {
    if (!label) return 'N/A';
    return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
};

/**
 * @typedef {Object} BadgeProps
 * @property {string | null | undefined} label - The text content of the badge.
 * @property {string} bgColor - The Tailwind CSS class for the background color (e.g., 'bg-green-100').
 * @property {string} textColor - The Tailwind CSS class for the text color (e.g., 'text-green-800').
 * @property {string} [borderColor] - Optional: The Tailwind CSS class for the border color (e.g., 'border-green-400').
 */

/**
 * A reusable, styled component for displaying short status labels or tags.
 * It automatically capitalizes the first letter of the label.
 *
 * @param {BadgeProps} props - The component props.
 * @returns {JSX.Element} The rendered <span> element.
 */
const Badge = ({ label, bgColor, textColor, borderColor }) => {

    const Badgelabel = capitalizeFirstLetter(label);

    const badgeStyles = `
        px-2 py-1 
        rounded 
        text-xs 
        font-medium 
        w-20 
        h-6 
        flex items-center justify-center 
        ${borderColor ? `border ${borderColor}` : ''} 
        ${bgColor} 
        ${textColor} 
        shadow-lg
    `;

    return <span className={badgeStyles}>{Badgelabel}</span>;
};

export default Badge;